export const getTeam = (state) => state.team;

export const getTeamMembers = (state) => getTeam(state).membersList;

const teamMemberToListItem = (teamMember) => ({
    id: teamMember.userId,
    full_name: teamMember.name,
    username: teamMember.username,
    email: teamMember.email,
    imageUrl: teamMember.imageUrl
});

export const getTeamMembersAsInputItems = (state) => {
    const teamMembers = getTeamMembers(state);
    return Object.values(teamMembers).map(teamMemberToListItem);
};
